var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDropdownClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "dropdown button"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 167",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "M5.5 104.141a.729.729 0 0 1-.545-.252l-4.73-5.28a.932.932 0 0 1 0-1.216.715.715 0 0 1 1.089 0l4.186 4.672 4.185-4.672a.715.715 0 0 1 1.089 0 .932.932 0 0 1 0 1.216l-4.73 5.28a.729.729 0 0 1-.544.252z",
    transform: "translate(6.999 -88.141)",
    style: {
      fill: "#0222ba"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownClosed);
export default __webpack_public_path__ + "static/media/icon-dropdown-closed.ba0f3baa93004b757bb3efda88e57e43.svg";
export { ForwardRef as ReactComponent };